export const API_BASE = (process.env.REACT_APP_API_BASE ?? 'http://localhost:3003/api').replace(
  /\/+$/,
  ''
);

async function req<T = unknown>(path: string, opts: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, opts);

  const text = await res.text();

  let data: unknown = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }

  if (!res.ok) {
    let message = res.statusText || 'Request failed';

    if (
      data &&
      typeof data === 'object' &&
      'detail' in data &&
      typeof (data as { detail: unknown }).detail === 'string'
    ) {
      message = (data as { detail: string }).detail;
    }

    throw new Error(message);
  }

  return data as T;
}

export function get<T = unknown>(path: string): Promise<T> {
  return req<T>(path);
}

export function post<T = unknown, B = unknown>(path: string, body?: B): Promise<T> {
  return req<T>(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  });
}

export function patch<T = unknown, B = unknown>(path: string, body?: B): Promise<T> {
  return req<T>(path, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  });
}

export function del<T = unknown, B = unknown>(path: string, body?: B): Promise<T> {
  return req<T>(path, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  });
}
